module.exports = __webpack_public_path__ + "76af7c92e1dd62a6aae8bc93620e0ebc.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/motomundo.png
// module id = 614
// module chunks = 0